import type {
    InitialVariantState,
    VariantAttribute,
    VariantState,
} from 'types/variant';

import generateOptions from './generateOptions';

export default function initiateState(
    initialVariantState: InitialVariantState,
): VariantState {
    const { variants, attributes: order } = initialVariantState;
    const attributes: VariantAttribute[] = [];

    for (let i = 0; i < variants.length; i += 1) {
        const {
            id,
            VariantDefiningAttributes,
            price,
            originalPrice,
            priceType,
            stock,
            stockStatus,
            nextDeliveryDate,
        } = variants[i];
        if (VariantDefiningAttributes) {
            const attrs = JSON.parse(VariantDefiningAttributes);
            const requirement: Record<string, any> = {};
            for (let j = 0; j < order.length; j += 1) {
                const attribute = order[j].key;
                const value = attrs[attribute];
                attributes.push({
                    stock,
                    stockStatus,
                    nextDeliveryDate,
                    label: value.Value,
                    swatch: value.Swatch,
                    disabled: false,
                    requirement: { ...requirement },
                    attribute,
                    code: value.Value,
                    price: {
                        price,
                        originalPrice,
                        priceType,
                    },
                    id,
                });
                requirement[attribute] = value.Value;
            }
        }
    }

    let selection: Record<string, string | number> = {};

    if (initialVariantState.variant) {
        const attrs = JSON.parse(
            initialVariantState.variant.VariantDefiningAttributes,
        );
        const keys: string[] = Object.keys(attrs);
        selection = keys.reduce(
            (a, b) => ({ ...a, [b]: initialVariantState.variant?.[b] }),
            {},
        );
    }

    return {
        attributes,
        selection,
        options: generateOptions(attributes, selection, order),
        variant: initialVariantState.variant,
        variants,
        order,
    };
}
